/*
Nav item for eg villa region
*/

import React from "react";
import { Link } from "gatsby";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons";

const DropdownItem = ({
  title,
  to,
  items,
  className = "",
  dropRight,
  isExpanded,
  onClick,
  innerRef,
}) => {
  let dropdownMenu = null;

  if (isExpanded(to, items)) {
    dropdownMenu = (
      <ul aria-labelledby="homeDropdownMenuLink" className="dropdown-menu show">
        {items.map(link => {
          if (link.items) {
            return (
              <DropdownItem
                to={link.to}
                key={link.title}
                title={link.title}
                items={link.items}
                dropRight
                isExpanded={isExpanded}
                onClick={onClick}
              />
            );
          }
          return (
            <Link key={link.title} to={link.to} className="dropdown-item">
              {link.title}
            </Link>
          );
        })}
      </ul>
    );
  }
  if (dropRight) {
    className += " dropright";
  }
  return (
    <li className={`nav-item dropdown ${className}`} ref={innerRef}>
      <a
        href="/"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        className="nav-link dropdown-toggle active"
        onClick={e => {
          e.preventDefault();
          onClick(to);
        }}
      >
        {title}
        <FontAwesomeIcon
          icon={dropRight ? faAngleRight : faAngleDown}
          fixedWidth
          size="sm"
        />
      </a>
      {dropdownMenu}
    </li>
  );
};

export default DropdownItem;
